import S from '../combosDrawsTemplate/settings'
import { POSITIONS, POSITIONS_ON_PREFLOP, RANKS, SUITS } from './constants'
import styles from '../Hands/Hands.module.scss'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import React from 'react'

export function toFixed(num, fixed) {
	if (num === '') {
		return ''
	}

	if (!num) {
		num = 0.0
	}

	num = num.toFixed(fixed)

	return num

	// let re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
	// return num.toString().match(re)[0];
}

export function getBadBranchText(badBranchType, play, villGtoFreq, villGtoRange, diffBet) {
	const badBranchTypes = {
		played: play,
		villain_gto_freq: villGtoFreq,
		villain_gto_range: villGtoRange,
		diff_bet: diffBet,
	}

	return badBranchTypes[badBranchType]
}

// export function getDefaultStack(spot_id, libraries) {
// 	const defStacks = (libraries) => {
// 		const obj = {}
// 		libraries && libraries.map((el) => el.spots.map((s) => (obj[s.spot_id] = s.default_stack)))
//
// 		return obj
// 	}
//
// 	return defStacks(libraries)[spot_id]
// }

export const hexToRgb = (hex, opacity) => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
	if (result) {
		const r = parseInt(result[1], 16)
		const g = parseInt(result[2], 16)
		const b = parseInt(result[3], 16)

		return [r, g, b, opacity && opacity]
	}

	return null
}

export const rgbaToHex = (color) => {
	if (/^rgb/.test(color)) {
		const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
		let hex = `#${((1 << 24) + (parseInt(rgba[0], 10) << 16) + (parseInt(rgba[1], 10) << 8) + parseInt(rgba[2], 10))
			.toString(16)
			.slice(1)}`

		// added alpha param if exists
		if (rgba[4]) {
			const alpha = Math.round(0.1 * 255)
			const hexAlpha = (alpha + 0x10000).toString(16).substr(-2).toUpperCase()
			hex += hexAlpha
		}

		return hex
	}

	return color
}

export const getRGBAColor = (minColor, maxColor, opacity) => {
	if (!minColor || !maxColor) {
		return 'none'
	}

	return `rgba(
	${Math.ceil(maxColor[0] + (minColor[0] - maxColor[0]) * opacity)},
	${Math.ceil(maxColor[1] + (minColor[1] - maxColor[1]) * opacity)},
	${Math.ceil(maxColor[2] + (minColor[2] - maxColor[2]) * opacity)}
	)`
}

export const getPosColor = (color1, color2, op, maxVal) =>
	'rgba(' +
	`${Math.ceil(color1[0] - ((color1[0] - color2[0]) / maxVal) * op)}, ` +
	`${Math.ceil(color1[1] - ((color1[1] - color2[1]) / maxVal) * op)}, ` +
	`${Math.ceil(color1[2] - ((color1[2] - color2[2]) / maxVal) * op)}` +
	')'

export const getNegColor = (color1, color2, op, maxVal, minVal) =>
	'rgba(' +
	`${Math.ceil(color1[0] - (color1[0] - color2[0]) * Math.abs(op / minVal))}, ` +
	`${Math.ceil(color1[1] - (color1[1] - color2[1]) * Math.abs(op / minVal))}, ` +
	`${Math.ceil(color1[2] - (color1[2] - color2[2]) * Math.abs(op / minVal))}` +
	')'

export function isJsonString(str) {
	try {
		JSON.parse(str)
	} catch (e) {
		return false
	}

	return true
}

export function debounce(func, wait) {
	let timeout

	return function () {
		// const context = this;
		const args = arguments
		const later = function () {
			timeout = null
			func.apply(this, args)
		}
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
	}
}

export function getValueWithSigh(v) {
	if (v) {
		return v > 0 ? '+' + v : v
	} else {
		return v
	}
}

export const convertationActionMultiStack = (name = '', raiseIndex = -1, isAllIn = false, isCopy = false) => {
	if (name.includes('Call')) {
		return 'C'
	}

	if (name.includes('Check')) {
		return 'X'
	}

	if (name.includes('Fold')) {
		return 'F'
	}

	if (isAllIn) {
		return isCopy ? 'A' : 'All In'
	}

	if (raiseIndex !== -1 && name.includes('Raise')) {
		return `R#${raiseIndex + 1}`
	}

	if (raiseIndex !== -1 && name.includes('Bet')) {
		return `B#${raiseIndex + 1}`
	}

	return name
}

export function processActionName(a, allIn) {
	if (a) {
		a = a.replace('Raise to', 'R ')
		a = a.replace('Raise', 'R ')
		a = a.replace('Bet', 'B ')
		a = a.replace('Check', 'X ')
		a = a.replace('Fold', 'F ')
		a = a.replace('Call', 'C ')

		// a = a.replace(' ', '')

		if (allIn && (a.includes('R') || a.includes('B'))) {
			return a + ' (All-In)'
		}

		return a
	}
}

export function getAvailableSpots(librariesResponse) {
	if (!librariesResponse) {
		return []
	}
	const availableLibraries = librariesResponse.libraries.filter((item) => item.is_free || item.license_active.active)

	return availableLibraries.map((item) => item.spots.map((spot) => spot.spot)).flat()
}

export function streetByQuery(q) {
	if (!q) {
		return null
	}
	const fRe = 'F\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){3}'
	const tRe = 'T\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){1}'
	const rRe = 'R\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){1}'

	const f = q.match(fRe)
	const t = q.match(tRe)
	const r = q.match(rRe)

	if (f === null) {
		return 'preflop'
	}

	if (t === null) {
		return 'flop'
	}

	if (r === null) {
		return 'turn'
	}

	return 'river'
}

export function humanFileSize(bytes, si = true, dp = 2) {
	const thresh = si ? 1000 : 1024

	if (Math.abs(bytes) < thresh) {
		return `${bytes} B`
	}

	const units = si
		? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
		: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	let u = -1
	const r = 10 ** dp

	do {
		bytes /= thresh
		++u
	} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

	return `${bytes.toFixed(dp)} ${units[u]}`
}

const isTaskCalculated = (spot) => !spot.statuses.some((item) => item.status === 'parsed')

const isCalculatingSpot = (spot) => spot.statuses.some((item) => item.status === 'to_calc')

export function buildTasks(
	tasksList,
	doneStatusLocale,
	parsedStatusLocale,
	noLicenseStatusLocale,
	runningStatusLocale
) {
	/* const isRunEnabled = useMemo(() => {
          const availableSpots = getAvailableSpots(librariesResponse)
          console.log("TEST ITERATION: ", spots.filter(item => availableSpots.includes(item.spot.spot_name)))
          return spots.filter(item => availableSpots.includes(item.spot.spot_name)).length > 0
      }, [getAvailableSpots(librariesResponse)])*/

	const tasks = []
	if (!tasksList) {
		return []
	}

	tasksList.task_list.forEach((task) => {
		// calculate status
		let noSpotLicense = false
		let status = ''
		let isRunEnabled = true
		let isRemoveEnabled = true
		let hasLicenseForThisTask = false
		let isTaskCalculatedTaskFlag = true
		let isCalculatingSpotFlag = false

		// get spots
		const spots = task.spots.map((spot) => {
			const spotWidth = (spot.overall / task.hands_count) * 100
			if (isTaskCalculatedTaskFlag) {
				isTaskCalculatedTaskFlag = !(!isTaskCalculated(spot) && spot.spot_license)
			}
			if (!isCalculatingSpotFlag) {
				isCalculatingSpotFlag = isCalculatingSpot(spot)
			}
			let spotDone = 0
			let spotError = 0

			// if spot has no license
			if (!spot.spot_license) {
				noSpotLicense = true
			}

			if (spot.spot_license) {
				hasLicenseForThisTask = true
			}

			// get statuses
			spot.statuses.forEach((status) => {
				if (status.status === 'calculated') {
					spotDone = status.count
				}

				if (status.status === 'error') {
					spotError = status.count
				}
			})

			return {
				spot,
				spotWidth,
				spotDone,
				spotError,
			}
		})

		// correct
		if (task.calculated) {
			status = `${doneStatusLocale}`
			isRunEnabled = false
		} else if (task.parsable && hasLicenseForThisTask && !isTaskCalculatedTaskFlag) {
			status = `${parsedStatusLocale}`
			isRunEnabled = true

			// todo: ask about this status
			/* if (task['exceeds_limit_job'])
                      status = 'No limit'*/
		} else if (task.parsable && isTaskCalculatedTaskFlag && !isCalculatingSpotFlag) {
			status = `${noLicenseStatusLocale}`
			isRunEnabled = false
		} else if (isCalculatingSpotFlag) {
			status = `${runningStatusLocale}`
			isRunEnabled = false
			isRemoveEnabled = false
		}

		/* if (task['exceeds_limit_job'])
                isRunEnabled = false;*/

		tasks.push({
			item: task,
			isRunEnabled,
			isRemoveEnabled,
			status,
			spots,
		})
	})

	return tasks
}

export function toUTCEndOfDay(m) {
	if (!m) {
		return null
	}

	const utcM = m.clone()
	const offset = utcM.utcOffset() * 60 * 1000

	return utcM.endOf('day').valueOf() + offset
}

export function toUTCStartOfDay(m) {
	if (!m) {
		return null
	}

	const utcM = m.clone()
	const offset = utcM.utcOffset() * 60 * 1000

	return utcM.startOf('day').valueOf() + offset
}

/**
 * Find position stack
 */
// export function getPositionsStacks(trace, heroPosition, villainPosition) {
//
//
//     let posEffStacks = {
//         [heroPosition]: [],
//         [villainPosition]: [],
//     };
//
//     let heroLastStreetBet = heroPosition === 'SB' ? 0.5 : heroPosition === 'BB' ? 1.0 : 0.0;
//     let villainLastStreetBet = villainPosition === 'SB' ? 0.5 : villainPosition === 'BB' ? 1.0 : 0.0;
//
//     let effStack = 0.0;
//
//
//     for (let i = 0; i < trace.length; i++) {
//         let t = trace[i];
//
//         // get effective stack
//         /*if (t.type === 'stack') {
//             //effStack = t.actions[t.choose].replace('bb', '').toNumber();
//
//         }*/
//
//         // make last street bet = 0, if next street
//         if (t.type === "flop" || t.type === "turn" || t.type === "river") {
//             posEffStacks[heroPosition].push(heroLastStreetBet);
//             posEffStacks[villainPosition].push(villainLastStreetBet);
//             heroLastStreetBet = 0.0;
//             villainLastStreetBet = 0.0;
//         }
//
//         // find last street bet
//         if (t.type === "action") {
//             if (t.player === heroPosition) {
//                 let action = t.actions[t.choose];
//                 let betAmount = action.split(' ').length > 1 ? action.split(' ')[1] : 0.0;
//                 heroLastStreetBet = heroLastStreetBet < betAmount ? betAmount : heroLastStreetBet;
//             } else if (t.player === villainPosition) {
//                 let action = t.actions[t.choose];
//                 let betAmount = action.split(' ').length > 1 ? action.split(' ')[1] : 0.0;
//                 villainLastStreetBet = villainLastStreetBet < betAmount ? betAmount : villainLastStreetBet;
//             }
//         }
//     }
//
//     posEffStacks[heroPosition].push(heroLastStreetBet);
//     posEffStacks[villainPosition].push(villainLastStreetBet);
//
//
//     return posEffStacks;
// }
//

export function getContrastColor(hex) {
	let color = hexToRgbContrastColor(hex)

	if (!color) {
		return undefined
	}

	const luminance = (0.299 * color.r + 0.587 * color.g + 0.114 * color.b) / 255

	if (luminance > 0.5) {
		return '#15171F'
	}

	return '#fff'
}

function hexToRgbContrastColor(hex) {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

	return result
		? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16),
		  }
		: null
}

export function generateRandomCard() {
	const { RANKS, SUITS } = S

	const randomRank = RANKS[Math.floor(Math.random() * RANKS.length)]
	const randomSuit = SUITS[Math.floor(Math.random() * SUITS.length)]

	return randomRank + randomSuit
}

export function generateUniqueCard(currentBoard) {
	const card = generateRandomCard()

	return currentBoard.includes(card) ? generateUniqueCard(currentBoard) : card
}

export function generateRandomBoard(currentBoard, numberCards) {
	const board = [...currentBoard]

	for (let i = 0; i < numberCards; i++) {
		board.push(generateUniqueCard(board))
	}

	return board
}

export const getGradientHands = ({ colors, percents, isOffset = true }) => {
	const gradient = []
	const gradientWidthArray = []
	let sum = 0
	if (percents) {
		for (let i = 0; i < percents.length; i++) {
			sum += percents[i]
		}

		let offset = 0

		for (let i = 0; i < percents.length; i++) {
			const x = (100 * percents[i]) / sum
			const width = x + offset

			gradientWidthArray.push(`${width}% 100%`)
			gradient.push(`linear-gradient(to right, ${colors[i]}, ${colors[i]})`)
			if (isOffset) {
				offset += x
			}
		}
	}

	return [gradient, gradientWidthArray]
}

export const createActionsOrder = (actionsOrder) => {
	return actionsOrder
		.map((action) => {
			if (action === 'R') {
				return ['Bet', 'Raise']
			}

			if (action === 'C') {
				return ['Check', 'Call']
			}

			if (action === 'F') {
				return 'Fold'
			}

			return 'All_In'
		})
		.flat()
}

export const getActionShortName = (action) => {
	switch (action) {
		case 'Bet': {
			return 'B'
		}
		case 'Raise': {
			return 'R'
		}
		case 'Check': {
			return 'X'
		}
		case 'Call': {
			return 'C'
		}
		case 'Fold': {
			return 'F'
		}
		case 'All_In': {
			return 'A'
		}
	}
}

export const createActionsValueOrder = (actionsOrder, key) => {
	return actionsOrder.map((action) => key + getActionShortName(action))
}

export const createButtonsOrder = (actionsOrder) => {
	const buttonNames =
		actionsOrder &&
		actionsOrder.map((action) => {
			switch (action) {
				case 'Bet':
				case 'Raise': {
					return 'B/R'
				}
				case 'Check':
				case 'Call': {
					return 'X/C'
				}
				case 'Fold': {
					return 'F'
				}
				case 'All_In': {
					return 'A'
				}
			}
		})

	return [...new Set(buttonNames)]
}

export const setSortedActions = (actionsOrder, actions, key = null) => {
	let getCompareValue

	if (key) {
		getCompareValue = (value) => value.name[0]
	} else {
		getCompareValue = (value) => value[0]
	}

	return [...actions].sort((a, b) => {
		if (getCompareValue(a) === 'B') {
			return actionsOrder.indexOf('R') - actionsOrder.indexOf(getCompareValue(b))
		}

		if (getCompareValue(b) === 'B') {
			return actionsOrder.indexOf(getCompareValue(a) - actionsOrder.indexOf('R'))
		}

		return actionsOrder.indexOf(getCompareValue(a)) - actionsOrder.indexOf(getCompareValue(b))
	})
}

export const createAllInsOrder = (actionsOrder) => actionsOrder.map((action) => action === 'A' || action === 'All_In')

export const sortedOrderPositions = (positions) =>
	positions.sort((a, b) => POSITIONS_ON_PREFLOP.indexOf(a) - POSITIONS_ON_PREFLOP.indexOf(b))

export const sortedOrderPositionsFromObj = (positionsObj) => {
	const key = Object.keys(positionsObj)
	const positions = key.sort((a, b) => POSITIONS.indexOf(a) - POSITIONS.indexOf(b))
	const sortedPositionsObj = {}

	positions.forEach((position) => {
		sortedPositionsObj[position] = positionsObj[position]
	})

	return sortedPositionsObj
}

export const sortBetSize = (a, b) => {
	const first = +a.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)
	const second = +b.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)

	return first - second
}

export const getSameAction = (actionFromDifferentStack, actionFromBiggestStack) => {
	if (!actionFromDifferentStack) {
		return null
	}

	const isCheckFoldCall =
		(actionFromDifferentStack.action.toLowerCase().includes('check') &&
			actionFromBiggestStack.action.toLowerCase().includes('check')) ||
		(actionFromDifferentStack.action.toLowerCase().includes('fold') &&
			actionFromBiggestStack.action.toLowerCase().includes('fold')) ||
		(actionFromDifferentStack.action.toLowerCase().includes('call') &&
			actionFromBiggestStack.action.toLowerCase().includes('call'))

	if (actionFromDifferentStack.isAllIn && actionFromBiggestStack.isAllIn) {
		return actionFromDifferentStack // find All In
	}

	if (isCheckFoldCall) {
		return actionFromDifferentStack // find Call, Check, Fold
	}

	if (
		actionFromDifferentStack.raiseIndex > -1 &&
		actionFromBiggestStack.raiseIndex > -1 &&
		actionFromDifferentStack.raiseIndex === actionFromBiggestStack.raiseIndex &&
		!actionFromDifferentStack.isAllIn &&
		!actionFromBiggestStack.isAllIn
	) {
		return actionFromDifferentStack // find bet/raise
	}
}

export const checkCardInFilters = (card, combos, draws, suits, threshold, field = '') => {
	const holeSuit = card.s[1] + card.s[3]
	const checkCombo = combos.includes(card.com)
	const checkDraw = draws.includes(card.draw) || draws.length === 0
	const checkSuits = suits.includes(holeSuit)

	if (field === 'abs') {
		return checkDraw && checkSuits && checkCombo
	}

	return checkDraw && checkSuits && checkCombo && card.abs > threshold
}

export const getFullName = (shortName) => {
	const copyName = shortName?.slice(0)
	let firstLatter
	if (shortName?.includes('#')) {
		firstLatter = shortName?.split('#')[0]
	} else {
		firstLatter = shortName?.split(' ')[0]
	}

	switch (firstLatter) {
		case 'X': {
			return copyName.replace('X', 'Check')
		}
		case 'C': {
			return copyName.replace('C', 'Call')
		}
		case 'F': {
			return copyName.replace('F', 'Fold')
		}
		case 'R': {
			return copyName.replace('R', 'Raise')
		}
		case 'B': {
			return copyName.replace('B', 'Bet')
		}
		default: {
			return shortName
		}
	}
}

export const filteredValues = (action, combos, draws, suits, threshold) => {
	if (!combos || !draws) {
		return action?.values
	}

	return action?.values.map((value) => {
		if (value?.c.length > 0) {
			const cardsInFilters = value?.c.filter((card) => checkCardInFilters(card, combos, draws, suits, threshold))

			return {
				...value,
				c: cardsInFilters,
			}
		}

		return value
	})
}

export const absAction = (action) =>
	action?.values.reduce((acc, value) => {
		if (value.p >= 0) {
			return acc + value.c.reduce((acc, cur) => acc + cur.abs, 0)
		}

		return acc
	}, 0)

export const absPlayed = (action) =>
	action?.values.reduce((acc, value) => {
		if (value.p >= 0) {
			return acc + value.c.reduce((acc, cur) => acc + cur.abs * cur.val, 0)
		}

		return acc
	}, 0)

export const calculateCombos = (action) => {
	return action?.values.reduce((acc, cur) => {
		return acc + cur?.c.reduce((acc, cur) => acc + cur.val * cur.abs, 0)
	}, 0)
}

export const calculateGtoRange = (action) => {
	const clearAction = action?.values.filter((value) => value.p)

	return clearAction.reduce((acc, cur) => {
		if (cur.p >= 0) {
			const pl = cur.c.reduce((acc, cur) => acc + cur.abs * cur.val, 0)

			return acc + pl
		}

		return acc
	}, 0)
}

const calcSizings = (action, pot, prevAction, trace, indexPot, isTraceAllIn) => {
	if (action.startsWith('Bet')) {
		const valueBet = +action.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)

		return isTraceAllIn ? `${toFixed((valueBet / pot) * 100, 0)}%` : `Bet ${toFixed((valueBet / pot) * 100, 0)}%`
	}

	if (action.includes('Call')) {
		return action.slice(0, 4)
	}

	if (action.startsWith('Raise')) {
		const valueRaise = +action.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)
		let previousAction = +prevAction.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)

		if (prevAction.includes('bb') || !!prevAction.match(/^[0-9]+$/) || prevAction.includes('-')) {
			return isTraceAllIn ? `${toFixed(valueRaise, 2)}x` : `Raise ${toFixed(valueRaise, 2)}x`
		}

		if (prevAction.includes('Fold')) {
			previousAction = 1

			for (let i = 1; i < indexPot; i++) {
				let choose = trace[i].choose
				let choosedAction = trace[i].actions[choose]

				if (choosedAction.includes('Bet') || choosedAction.includes('Raise')) {
					previousAction = +choosedAction.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)
				}
			}
		}

		return isTraceAllIn
			? `${toFixed(valueRaise / previousAction, 2)}x`
			: `Raise ${toFixed(valueRaise / previousAction, 2)}x`
	}

	return action
}

export const getSizingsData = (trace, viewerSizings, isUseAllin, isTraceAllIn = false) => {
	const data = []

	for (let i = 0; i < trace?.length; i++) {
		const traceItem = trace[i]
		const actionType = traceItem.type === 'action'
		const indexPot = trace.indexOf(traceItem)
		const prevAction = i > 0 && trace[i - 1].actions[trace[i - 1].choose]

		const sizings = {}

		if (actionType) {
			const pot = traceItem.pot
			const actions = traceItem.actions

			for (let j = 0; j < actions.length; j++) {
				const isAllin = traceItem.is_allins[j]
				let action

				if (viewerSizings) {
					if (isUseAllin) {
						action = calcSizings(actions[j], pot, prevAction, trace, indexPot)
					} else {
						action = isAllin
							? isTraceAllIn
								? `All in ${calcSizings(actions[j], pot, prevAction, trace, indexPot, isTraceAllIn)}`
								: `All in`
							: calcSizings(actions[j], pot, prevAction, trace, indexPot)
					}
				} else {
					action = traceItem.actions[j]
				}

				sizings[traceItem.actions[j]] = action
			}

			data.push(sizings)
		} else {
			data.push(null)
		}
	}

	return data
}

export const tooltipContent = (title, description, link = null) => (
	<div className={styles.helpContentContainer}>
		<p>
			{title}: {description}
			{link && (
				<a href={link.href} target='_blank' rel='noreferrer'>
					{link.title}
				</a>
			)}
		</p>
	</div>
)

export const HelpIcon = ({ title, description, link }) => {
	return (
		<Tooltip
			placement='bottomRight'
			title={tooltipContent(title, description, link)}
			destroyTooltipOnHide
			mouseLeaveDelay={0.01}
		>
			<QuestionCircleOutlined className={styles.helpIcon} />
		</Tooltip>
	)
}

export const snakeToCamel = (str) =>
	str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))

export const rgbString = (colorHex, opacity) => {
	const rgba = hexToRgb(colorHex, opacity)

	return Object.values(rgba).join(', ')
}

export const getMinimalPriceOfLib = (lib) => {
	const prices = lib.license_type
		.map((item) => (item.price_discount ? item.price_discount / item.license_duration : item.price))
		.filter((item) => !!item)

	return prices.length > 0 ? Math.min(...prices) : null
}

export const checkIsFiltersEmpty = (obj) => {
	let isNotEmpty = 0

	Object.entries(obj).forEach(([key, value]) => {
		// filter useless value
		switch (key) {
			case 'texture':
			case 'filterMode': {
				return
			}
		}

		if (!value) {
			return
		}

		switch (typeof value) {
			case 'string': {
				if (key === 'filterMode') {
					break
				}

				isNotEmpty++
				break
			}
			case 'object': {
				if (Array.isArray(value)) {
					isNotEmpty += value.filter((filter) => filter && filter !== 'Any').length
					break
				}

				isNotEmpty += Object.entries(value).filter(([_, value]) => {
					if (Array.isArray(value)) {
						return !value?.includes('Any')
					}

					if (value) {
						return value
					}

					return false
				}).length
				break
			}
			case 'number': {
				isNotEmpty++
				break
			}
		}
	})

	return isNotEmpty > 0
}

export const applyCrossFilters = (allFiltersValues, rows, copyAllFilters, filtersKeys, isStart = false) => {
	Object.entries(allFiltersValues).forEach(([key, values]) => {
		const data = []

		rows: for (let i = 0; i < rows.length; i++) {
			const row = rows[i]

			for (const filterName in copyAllFilters) {
				if (key === filterName) {
					continue
				}

				if (!copyAllFilters[filterName].includes('Any') && !copyAllFilters[filterName].includes(row[filterName])) {
					continue rows
				}
			}

			data.push(row)
		}

		const crossFilter = filtersKeys.reduce((acc, curr) => {
			acc[curr] = new Set()

			return acc
		}, {})

		data.forEach((row) => {
			for (const rowKey in row) {
				if (filtersKeys.includes(rowKey) && key === rowKey) {
					crossFilter[key].add(row[rowKey])
				}
			}
		})

		values.forEach((item) => {
			item.isActive = crossFilter[key].has(item.filterValue)
		})
	})

	if (!isStart) {
		for (const category in allFiltersValues) {
			const categoryFilterCopy = copyAllFilters[category].slice()

			allFiltersValues[category].forEach((item) => {
				if (!item.isActive && categoryFilterCopy.includes(item.filterValue)) {
					const index = categoryFilterCopy.indexOf(item.filterValue)

					categoryFilterCopy.splice(index, 1)
				}
			})

			if (categoryFilterCopy.length === 0) {
				copyAllFilters[category] = ['Any']
			} else {
				copyAllFilters[category] = categoryFilterCopy
			}
		}
	}

	return { allFiltersValues, copyAllFilters }
}

export const changeSuit = (card, isUpSuit) => {
	const suit = card.slice(1)
	let nextSuit

	if (isUpSuit) {
		let indexNextSuit = SUITS.indexOf(suit) + 1
		nextSuit = SUITS[indexNextSuit > SUITS.length - 1 ? 0 : indexNextSuit]
	} else {
		let indexNextSuit = SUITS.indexOf(suit) - 1
		nextSuit = SUITS[indexNextSuit < 0 ? SUITS.length - 1 : indexNextSuit]
	}

	return card.slice(0, 1) + nextSuit
}

export const changeRank = (card, isUp) => {
	const suit = card.slice(0, 1)
	let nextRank

	if (isUp) {
		let indexNextRank = RANKS.indexOf(suit) - 1
		nextRank = RANKS[indexNextRank < 0 ? RANKS.length - 1 : indexNextRank]
	} else {
		let indexNextRank = RANKS.indexOf(suit) + 1
		nextRank = RANKS[indexNextRank > RANKS.length - 1 ? 0 : indexNextRank]
	}

	return nextRank + card.slice(1)
}

export const isLastedRank = (board, card, isUp) => {
	let index = RANKS.indexOf(card[0])
	const nextRanks = isUp ? RANKS.slice(0, index) : RANKS.slice(index + 1)

	return nextRanks.filter((rank) => !board.includes(rank + card[1])).length === 0
}

export const arrayWithSelectedHands = (copyMatrix) => {
	return copyMatrix
		.slice()
		.flat()
		.filter((cell) => cell.selected)
		.map((cell) => cell.cellText)
}

export const isLibraryLocked = (libraryName, librariesResponse) => {
	if (librariesResponse) {
		const selectedLibrary = librariesResponse.libraries.find((el) => el.library_name === libraryName)

		return (!selectedLibrary.is_free && !selectedLibrary.license_active.active) || selectedLibrary.is_free
	}

	return false
}

export const getLicenseList = (licensesResponse) => {
	const licenses = { active: [], inactive: [] }
	const licensesArr = licensesResponse ? licensesResponse.license : []

	if (licensesArr) {
		licensesArr.forEach((license) => {
			license.key = license.name + license.begin_date + license.expire_date

			if (license.is_active) {
				licenses.active.push(license)
			}

			if (!license.is_active) {
				licenses.inactive.push(license)
			}
		})
	}

	return licenses
}

export const formattedDate = (date) => {
	const copyDate = date?.split('/').reverse().join('-')

	return copyDate
		? new Date(copyDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
		: null
}

export const createFeaturesStructure = (data, result = []) => {
	if (!data) {
		return []
	}

	for (const item of data) {
		if (item.features) {
			const createFeature = () => {
				const isFeature = item.features.some((feature) => feature.key)

				if (isFeature) {
					return item.features.map((feature) => ({
						key: feature.key,
						name: feature.name,
						value: feature.value,
						isShowHelp: feature?.show_help || false,
					}))
				}

				return createFeaturesStructure(item.features, [])
			}

			const new_item = {
				name: item.name,
				features: createFeature(),
			}

			result.push(new_item)
		}
	}

	return result
}

export const blockedReports = (libraryName, libraries) => {
	const selectedLibrary = libraries.find(({ library_name }) => library_name === libraryName)
	const activeTier = selectedLibrary.active_tier

	return selectedLibrary.tiers.find(({ tier_id }) => tier_id === activeTier).blocked
}

export const getLimitsInformation = (libraries, libraryName) => {
	const lib = libraries.find(({ library_name }) => library_name === libraryName)
	const tier = lib?.tiers.find(({ tier_id }) => lib.active_tier === tier_id)
	const currentTierIndex = lib.tiers.findIndex((item) => item.tier_id === tier.tier_id)

	return lib.tiers.length > 0 ? lib.tiers[currentTierIndex + 1].tier_id : ''
}
